import React, { useState, useEffect } from "react";
import { Controller, useWatch, useFieldArray } from "react-hook-form";
import { Toast } from "../../../../shared/Toast";
import api from "../../../../services/api";
export const HIDDEN_FIELD_VENDOR_IDS = [3, 4];

export const isHiddenFieldVendor = (vendorId) =>
  vendorId !== undefined && vendorId !== null && vendorId !== "" &&
  HIDDEN_FIELD_VENDOR_IDS.includes(Number(vendorId));

export const buildOthersPayload = (data) => ({
  button_color: data?.button_color || "",
  font_color: data?.font_color || "",
  brand_url: data?.brand_url || "",
});

export const buildProductPayload = (data) => {
  const hideExtras = isHiddenFieldVendor(data?.vendor_id);
  const isMultiple = data?.amount_type === "multiple";
  return {
    product_name: hideExtras ? '' : data?.product_name,
    product_description: hideExtras ? '' : data?.product_description,
    product_img_urls: hideExtras ? '' : data?.productImage,
    place: hideExtras ? '' : (data?.place || ''),
    event_date: hideExtras ? '' : data?.event_date,
    amount: hideExtras ? 0 : (isMultiple ? 0 : (Number(data?.amount) || 0)),
    product_amounts: hideExtras
      ? []
      : (isMultiple
        ? (data?.product_amounts || []).map((p) => ({ title: p.title, amount: Number(p.amount) || 0 }))
        : []),
    client_query_phone_number: data?.client_query_phone_number,
    client_notify_url: data?.client_notify_url,
    in_app_button_text: data?.in_app_button_text,
    transcation_type: data?.transcation_type,
    vendor_id: +data?.vendor_id,
    html: hideExtras ? (data?.html || "") : '',
    others: buildOthersPayload(data),
  };
};
const ProductSubForm = ({ control, register, setValue, errors, editdata }) => {
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(editdata?.product_img_urls || "");
  const [progress, setProgress] = useState(0);
  const [vendorOptions, setVendorOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api({
          url: `/vendor/getvendors`,
          method: "GET",
          responseType: "json",
        });
        if (cancelled) return;
        const list = Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data)
            ? res.data
            : [];
        setVendorOptions(list);
      } catch (error) {
        Toast("error", "Failed to load vendors");
      }
    })();
    return () => { cancelled = true; };
  }, []);
  // Watch for conditional payment field
  const toLocalDate = (epoch) => {
  const d = new Date(epoch * 1000);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
  const transactionType = useWatch({
    control,
    name: "transcation_type",
    defaultValue: editdata?.transcation_type || "form"
  });
  const selectedVendorId = useWatch({
    control,
    name: "vendor_id",
    defaultValue: editdata?.vendor_id || ""
  });
  const hideExtraFields = isHiddenFieldVendor(selectedVendorId);
  const editAmounts = Array.isArray(editdata?.product_amounts) ? editdata.product_amounts : [];
  const initialAmountType = editAmounts.length > 1 ? "multiple" : (editdata?.amount_type || "single");
  const amountType = useWatch({
    control,
    name: "amount_type",
    defaultValue: initialAmountType
  });
  const { fields: amountFields, append: appendAmount, remove: removeAmount } = useFieldArray({
    control,
    name: "product_amounts"
  });
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate());
    const minDateString = yesterday.toISOString().split('T')[0];
  // --- Your Image Upload Logic ---
  const imageUpload = async () => {
    try {
      const formData1 = new FormData();
      formData1.append("files", image);

      let response = await api({
        url: `/upload/brandImage`,
        method: "POST",
        responseType: "json",
        data: formData1,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });

      if (response.code === 200) {
        const uploadedUrl = response.data.data;
        setImageUrl(uploadedUrl);
        // Sync the URL back to React Hook Form state
        setValue("productImage", uploadedUrl, { shouldValidate: true });
      } else {
        setProgress(0);
        setValue("productImage", null);
        setImage(null);
        Toast("error", response.data.message);
      }
    } catch (error) {
      Toast("error", error.message || "Upload failed");
    }
  };

  useEffect(() => {
    if (editdata?.product_img_urls) {
      setValue("productImage", editdata.product_img_urls, { shouldValidate: false });
    }
    if (editdata?.transcation_type) {
      setValue("transcation_type", editdata.transcation_type);
    }
    setValue("amount_type", initialAmountType);
    if (editAmounts.length > 0) {
      setValue("product_amounts", editAmounts);
    } else if (initialAmountType === "multiple") {
      setValue("product_amounts", [{ title: "", amount: "" }]);
    }
    setValue("button_color", editdata?.others?.button_color || "#1976d2");
    setValue("font_color", editdata?.others?.font_color || "#ffffff");
    setValue("brand_url", editdata?.others?.brand_url || "");
    setValue("html", editdata?.html || "");
  }, []);

  useEffect(() => {
    if (image) imageUpload();
  }, [image]);

  useEffect(() => {
    if (hideExtraFields) {
      setValue("productImage", "");
      setValue("product_name", "");
      setValue("product_description", "");
      setValue("place", "");
      setValue("event_date", "");
      setImageUrl("");
      setImage(null);
      if (transactionType === "payment") {
        setValue("amount", "");
        setValue("amount_type", "single");
        setValue("product_amounts", []);
      }
    } else {
      setValue("html", "");
    }
  }, [hideExtraFields, transactionType]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const acceptedTypes = ["image/jpg", "image/jpeg", "image/webp", "image/png"];
      if (acceptedTypes.includes(file.type)) {
        setImage(file);
      } else {
        Toast("error", "Only jpg, jpeg, webp, png formats accepted");
        e.target.value = null; // Reset input
      }
    }
  };
const styles = {
  subFormContainer: { padding: '15px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fcfcfc', marginTop: '10px' },
  subTitle: { marginTop: 0, fontSize: '1rem', color: '#444', borderBottom: '1px solid #eee', paddingBottom: '5px' },
  field: { marginBottom: '15px', display: 'flex', flexDirection: 'column' },
  label: { fontSize: '0.85rem', fontWeight: 'bold', marginBottom: '4px' },
  input: { padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'inherit' },
  radioGroup: { display: 'flex', gap: '20px', marginTop: '5px' },
  radioLabel: { fontSize: '0.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' },
  err: { color: 'red', fontSize: '0.75rem', marginTop: '2px' }
};
  return (
    <div className="card p-3 mb-3 shadow-sm">
      <h5 className="mb-3">Product Information</h5>

      {/* Vendor Name (moved to top — controls visibility of other fields) */}
      <div className="mb-3">
        <label className="form-label">Vendor Name</label>
        <Controller
          name="vendor_id"
          control={control}
          defaultValue={editdata?.vendor_id || ""}
          render={({ field }) => (
            <select
              {...field}
              className="form-control"
              onChange={(e) => {
                field.onChange(e);
                const selected = vendorOptions.find((v) => String(v.value) === String(e.target.value));
                setValue("brand_url", selected?.brand_url || "");
              }}
            >
              <option value="">Select Vendor</option>
              {vendorOptions.map((v) => (
                <option key={v.value} value={v.value}>{v.label}</option>
              ))}
            </select>
          )}
        />
        <input type="hidden" {...register("brand_url")} />
      </div>

      {hideExtraFields && (
        <div className="mb-3">
          <label className="form-label">HTML *</label>
          <Controller
            name="html"
            control={control}
            rules={{ required: "HTML is required" }}
            defaultValue={editdata?.html || ""}
            render={({ field }) => (
              <textarea
                {...field}
                rows={12}
                placeholder="Paste full HTML here"
                className={`form-control ${errors.html ? 'is-invalid' : ''}`}
                style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
              />
            )}
          />
          {errors?.html && <span className="text-danger small">{errors.html.message}</span>}
        </div>
      )}

      {!hideExtraFields && (
        <>
      {/* 1. Image Upload Section */}
      <div className="mb-3">
        <label className="form-label">Product Image *</label>
        <input
          type="file"
          className={`form-control ${errors.productImage ? 'is-invalid' : ''}`}
          onChange={handleFileChange}
        />
        {/* Progress Bar */}
        {progress > 0 && progress < 100 && (
          <div className="progress mt-2" style={{ height: "5px" }}>
            <div className="progress-bar" style={{ width: `${progress}%` }}></div>
          </div>
        )}
        {/* Hidden input to hold the URL for React Hook Form validation */}
        <input type="hidden" {...register("productImage", { required: !editdata?.product_img_urls })} />

        {imageUrl && (
          <div className="mt-2">
            <img src={imageUrl} alt="Preview" style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '5px' }} />
            <p className="small text-success mt-1">Image uploaded successfully!</p>
          </div>
        )}
        {errors.productImage && <span className="text-danger small">Image is required</span>}
      </div>

      {/* 2. Product Name */}
      <div className="mb-3">
        <label className="form-label">Product Name *</label>
        <Controller
          name="product_name"
          control={control}
          rules={{ required: "Required" , maxLength: { value: 64, message: "Product Name cannot exceed 64 characters" } }}
          defaultValue={editdata?.product_name || ""}
          render={({ field }) => (
            <input {...field} placeholder="ps5" className={`form-control ${errors.product_name ? 'is-invalid' : ''}`} />
          )}
        />
        {errors?.product_name && <span className="text-danger small">Product Name is required</span> }
      </div>
        </>
      )}

      {/* 3. Query Phone Number */}
      <div className="mb-3">
        <label className="form-label">Query Phone Number (Optional)</label>
        <Controller
          name="client_query_phone_number"
          control={control}
          defaultValue={editdata?.client_query_phone_number || ""}
          rules={{ pattern: { value: /^(0\d{10}|[6-9]\d{9})$/, message: "Invalid phone number" } }}
          render={({ field }) => (
            <input {...field} placeholder="9876543210" className={`form-control ${errors.client_query_phone_number ? 'is-invalid' : ''}`} />
          )}
        />
        {errors?.client_query_phone_number && <span className="text-danger small">Invalid phone number</span> }
      </div>

       {/* 3. Notify url */}
       <div className="mb-3">
        <label className="form-label">Notify url (Optional)</label>
        <Controller
          name="client_notify_url"
          control={control}
          rules={{ pattern: { value: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]+$/, message: "Invalid URL" } }}
          defaultValue={editdata?.client_notify_url || ""}
          render={({ field }) => (
            <input {...field} placeholder="https://example.com/notify" className={`form-control ${errors.client_notify_url ? 'is-invalid' : ''}`} />
          )}
        />
        {errors?.client_notify_url && <span className="text-danger small">Invalid URL</span> }
      </div>

      {/* 3. Description */}
      {!hideExtraFields && (
      <div className="mb-3">
        <label className="form-label">Description *</label>
        <Controller
          name="product_description"
          control={control}
          rules={{ required: "Required" , maxLength: { value: 512, message: "Description cannot exceed 512 characters" } }}
          defaultValue={editdata?.product_description || ""}
          render={({ field }) => (
            <textarea {...field} placeholder="Description about project" className={`form-control ${errors.product_description ? 'is-invalid' : ''}`} />
          )}
        />
        {errors?.product_description && <span className="text-danger small">Product Description is required</span> }
      </div>
      )}

      {/* 3b. Button Text */}
      <div className="mb-3">
        <label className="form-label">Button Text *</label>
        <Controller
          name="in_app_button_text"
          control={control}
          rules={{ required: "Required" }}
          defaultValue={editdata?.in_app_button_text || ""}
          render={({ field }) => (
            <input {...field} placeholder="e.g. Buy Now, Register, Book Slot" className={`form-control ${errors.in_app_button_text ? 'is-invalid' : ''}`} />
          )}
        />
        {errors?.in_app_button_text && <span className="text-danger small">Button Text is required</span>}
      </div>
      {!hideExtraFields && (
        <>
        <div style={styles.field}>
        <label style={styles.label}>Place</label>
        <Controller
          name="place"
          rules={{ required: "Place is Required" }}
          control={control}
          defaultValue={editdata?.place || ""}
          render={({ field }) => <input placeholder="Hyderabad" className="form-control" {...field} style={styles.input} />}
        />
      </div>
        {errors.place && <span style={styles.err}>{errors.place.message}</span>}
     <div style={styles.field}>
  <label style={styles.label}>Date</label>
  <Controller
    name="event_date"
    control={control}

    rules={{required:'Date is Required'}}
    defaultValue={editdata?.event_date ? editdata?.event_date : ""}
    render={({ field }) => (
      <input
        {...field}
        className="form-control"
        type="text"
        style={styles.input}
      />
    )}
  />
</div>
      {errors.event_date && <span style={styles.err}>{errors.event_date.message}</span>}
        </>
      )}
      {/* 4. Payment Radio */}
      <div className="mb-3">
        <label className="form-label d-block">Listing Type</label>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" value="form" {...register("transcation_type")} defaultChecked={editdata?.transcation_type === 'form'} id="form" />
          <label className="form-check-label" htmlFor="form">Form</label>
        </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" id="payment" value="payment" {...register("transcation_type")} defaultChecked={editdata?.transcation_type === 'payment'} />
          <label className="form-check-label" htmlFor="payment">Payment</label>
        </div>
      </div>

      {/* 5. Conditional Payment Amount */}
      {transactionType === "payment" && !hideExtraFields && (
        <div className="mb-3">
          <label className="form-label d-block">Amount Type</label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              id="amount_single"
              value="single"
              {...register("amount_type")}
              defaultChecked={initialAmountType === "single"}
              onClick={() => {
                setValue("amount_type", "single");
                setValue("product_amounts", []);
              }}
            />
            <label className="form-check-label" htmlFor="amount_single">Single</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              id="amount_multiple"
              value="multiple"
              {...register("amount_type")}
              defaultChecked={initialAmountType === "multiple"}
              onClick={() => {
                setValue("amount_type", "multiple");
                setValue("amount", "");
                if (!amountFields.length) {
                  appendAmount({ title: "", amount: "" });
                }
              }}
            />
            <label className="form-check-label" htmlFor="amount_multiple">Multiple</label>
          </div>

          {amountType !== "multiple" ? (
            <div className="mt-2">
              <label className="form-label">Amount (INR) *</label>
              <Controller
                name="amount"
                control={control}
                rules={{ required: "Amount required", min: 1 }}
                defaultValue={editdata?.amount || ""}
                render={({ field }) => (
                  <input {...field} type="number" placeholder="10000" className={`form-control ${errors.amount ? 'is-invalid' : ''}`} />
                )}
              />
              {errors?.amount && <span className="text-danger small">Product Amount is required</span>}
            </div>
          ) : (
            <div className="mt-2">
              <label className="form-label">Amounts *</label>
              {amountFields.map((f, idx) => (
                <div key={f.id} className="d-flex gap-2 mb-2 align-items-start">
                  <div className="flex-grow-1">
                    <Controller
                      name={`product_amounts.${idx}.title`}
                      control={control}
                      rules={{ required: "Title required", maxLength: { value: 64, message: "Max 64 chars" } }}
                      defaultValue={f.title || ""}
                      render={({ field }) => (
                        <input {...field} placeholder="e.g. Standard, VIP" className={`form-control ${errors?.product_amounts?.[idx]?.title ? 'is-invalid' : ''}`} />
                      )}
                    />
                    {errors?.product_amounts?.[idx]?.title && (
                      <span className="text-danger small">{errors.product_amounts[idx].title.message}</span>
                    )}
                  </div>
                  <div style={{ width: '160px' }}>
                    <Controller
                      name={`product_amounts.${idx}.amount`}
                      control={control}
                      rules={{ required: "Amount required", min: { value: 1, message: "Min 1" } }}
                      defaultValue={f.amount || ""}
                      render={({ field }) => (
                        <input {...field} type="number" placeholder="10000" className={`form-control ${errors?.product_amounts?.[idx]?.amount ? 'is-invalid' : ''}`} />
                      )}
                    />
                    {errors?.product_amounts?.[idx]?.amount && (
                      <span className="text-danger small">{errors.product_amounts[idx].amount.message}</span>
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => removeAmount(idx)}
                    disabled={amountFields.length <= 1}
                  >
                    Remove
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="btn btn-outline-primary btn-sm mt-1"
                onClick={() => appendAmount({ title: "", amount: "" })}
              >
                + Add Amount
              </button>
            </div>
          )}
        </div>
      )}

      {/* 6. Button & Font Color */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Button Color</label>
          <Controller
            name="button_color"
            control={control}
            defaultValue={editdata?.others?.button_color || "#1976d2"}
            render={({ field }) => (
              <div className="d-flex align-items-center gap-2">
                <input {...field} type="color" className="form-control form-control-color" style={{ width: '60px', padding: '2px' }} />
                <input
                  type="text"
                  className="form-control"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                  placeholder="#1976d2"
                />
              </div>
            )}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Font Color</label>
          <Controller
            name="font_color"
            control={control}
            defaultValue={editdata?.others?.font_color || "#ffffff"}
            render={({ field }) => (
              <div className="d-flex align-items-center gap-2">
                <input {...field} type="color" className="form-control form-control-color" style={{ width: '60px', padding: '2px' }} />
                <input
                  type="text"
                  className="form-control"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                  placeholder="#ffffff"
                />
              </div>
            )}
          />
        </div>
      </div>

    </div>
  );
  
};

export default ProductSubForm;